export const DocumentIcon = ({ className = '' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.9355 3C13.9996 3 14.0612 3.02431 14.1066 3.06759C14.1519 3.11087 14.1774 3.16957 14.1774 3.23077V8.44338C14.1774 8.82554 14.5026 9.13569 14.9032 9.13569H19.2581C19.3222 9.13569 19.3838 9.16001 19.4291 9.20328C19.4745 9.24656 19.5 9.30526 19.5 9.36646V18.4615C19.5 19.1348 19.2196 19.7804 18.7205 20.2565C18.2214 20.7326 17.5445 21 16.8387 21H7.16129C6.45547 21 5.77856 20.7326 5.27947 20.2565C4.78038 19.7804 4.5 19.1348 4.5 18.4615V5.53846C4.5 4.86522 4.78038 4.21955 5.27947 3.7435C5.77856 3.26744 6.45547 3 7.16129 3H13.9355Z"
        fill="currentColor"
      />
      <path
        d="M16.7726 3.04278C16.6566 2.93507 16.5 3.04465 16.5 3.21698V7.26585C16.5 7.3951 16.5909 7.5 16.7028 7.5H19.3783C19.4741 7.5 19.5341 7.38386 19.4789 7.29395L17.0338 3.36309C16.9592 3.2436 16.8714 3.13591 16.7726 3.04278Z"
        fill="currentColor"
      />
    </svg>
  );
};
